<!-- SimpleFlexTableRow.vue -->
<script lang="ts" setup>
import { computed, inject } from 'vue';

    const props = defineProps<{
        rowClass?: string
    }>();

    const injectedRowClass = inject('rowClass');
    const injectedColumnClasses = inject<string[]|undefined>('columnClasses');

    const rowClass = computed(() => props.rowClass ?? injectedRowClass ?? "simple-row simple-row-zebra");    
</script>

<template>
    <div :class="rowClass">
        <template v-for="(colClass, index) in injectedColumnClasses">
            <div :class="colClass">
                <slot name="cell" :colIndex="index"></slot>
            </div>
        </template>
    </div>    
</template>